import React, { useState } from 'react';
import { RodmanChatAnimation } from './RodmanAnimation';
import './RodmanAnimationDemo.css';

// Demo component showcasing the Claude-style animations
const RodmanAnimationDemo = () => {
    const [messages, setMessages] = useState([]);
    const [demoMode, setDemoMode] = useState('chat'); // 'chat', 'showcase'

    // Simulate Rodman's response with delay
    const simulateRodmanResponse = (userMessage) => {
        const responses = [
            "Looking at tonight's matchups, I'm seeing strong value in the Lakers. They're hitting 78% at home against teams below .500, and the Pistons fit that profile perfectly. LeBron's been averaging 28-8-7 in these situations.",
            "The Warriors are my lock tonight. Curry's shooting 47% from three over the last 10 games, and they're facing a Wizards team that's dead last in perimeter defense. I'm projecting a 15+ point victory.",
            "Liverpool vs Manchester City is the match of the weekend. City's unbeaten streak looks vulnerable - Liverpool's high press has forced 23 turnovers in their last 3 matches. I'm taking Liverpool with the upset.",
            "My hot streak continues! I'm 42-18 (70%) over the last two weeks. The algorithm's really dialed in on these late-season patterns. Tonight's best bet: Celtics -8.5 against the Hornets.",
            "Championship race update: Nuggets are my pick to repeat. Jokić is putting up historic numbers - 29-13-10 over the last month. Their playoff experience gives them the edge over younger teams."
        ];

        const randomResponse = responses[Math.floor(Math.random() * responses.length)];
        
        setTimeout(() => {
            const rodmanMessage = {
                id: Date.now(),
                type: 'rodman',
                content: randomResponse,
                timestamp: new Date()
            };
            setMessages(prev => [...prev, rodmanMessage]);
        }, 500);
    };

    const handleSendMessage = (text) => {
        const userMessage = {
            id: Date.now(),
            type: 'user',
            content: text,
            timestamp: new Date()
        };
        setMessages(prev => [...prev, userMessage]);
        simulateRodmanResponse(text);
    };

    const startShowcase = () => {
        setMessages([]);
        setDemoMode('showcase');
        
        // Automated showcase sequence
        const showcaseSequence = [
            { delay: 500, type: 'user', content: 'Who wins tonight?' },
            { delay: 3500, type: 'user', content: 'Show me your hot streak picks' },
            { delay: 7000, type: 'user', content: "What's your confidence on the Lakers?" },
        ];

        showcaseSequence.forEach(({ delay, type, content }) => {
            setTimeout(() => {
                if (type === 'user') {
                    handleSendMessage(content);
                }
            }, delay);
        });
    };

    const resetDemo = () => {
        setMessages([]);
        setDemoMode('chat');
    };

    return (
        <div className="animation-demo-container">
            <div className="demo-controls">
                <h1>Rodman AI - Claude Animation Demo</h1>
                <div className="demo-buttons">
                    <button 
                        onClick={startShowcase}
                        className="demo-btn showcase"
                    >
                        🎬 Start Showcase
                    </button>
                    <button 
                        onClick={resetDemo}
                        className="demo-btn reset"
                    >
                        🔄 Reset Demo
                    </button>
                    <button 
                        onClick={() => setDemoMode(demoMode === 'chat' ? 'showcase' : 'chat')}
                        className="demo-btn mode"
                    >
                        {demoMode === 'chat' ? '💬 Chat Mode' : '🎯 Showcase Mode'}
                    </button>
                </div>
                <div className="demo-info">
                    <p>✨ Features demonstrated:</p>
                    <ul>
                        <li>Claude-style thinking animation with pulsing dots</li>
                        <li>Smooth typewriter effect for text streaming</li>
                        <li>Smart scroll positioning (stays at message top)</li>
                        <li>Seamless state transitions</li>
                        <li>Responsive design</li>
                    </ul>
                </div>
            </div>
            
            <div className="demo-chat-wrapper">
                <RodmanChatAnimation 
                    messages={messages}
                    onSendMessage={handleSendMessage}
                />
            </div>

            <div className="demo-features">
                <div className="feature-card">
                    <div className="feature-icon">⚡</div>
                    <h3>Thinking Animation</h3>
                    <p>Claude-style pulsing dots that create anticipation while processing</p>
                </div>
                <div className="feature-card">
                    <div className="feature-icon">✍️</div>
                    <h3>Typewriter Effect</h3>
                    <p>Natural text streaming that mimics real-time generation</p>
                </div>
                <div className="feature-card">
                    <div className="feature-icon">📍</div>
                    <h3>Smart Scrolling</h3>
                    <p>Maintains position at response top for immediate reading</p>
                </div>
                <div className="feature-card">
                    <div className="feature-icon">🎨</div>
                    <h3>Smooth Transitions</h3>
                    <p>Elegant animations between thinking, typing, and complete states</p>
                </div>
            </div>
        </div>
    );
};

export default RodmanAnimationDemo;